import { React, useState, useEffect, useRef } from "react";
import "./keyconcept.css";
import Header from "../layout/header/Header";
import Footer from "../layout/footer/Footer";
import Accordion from "react-bootstrap/Accordion";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Key_top from "../img/icon/Molecule_light_top.png";
import img_6 from "../img/icon/Molecule_light_w_1.png";
import { useGetAlltopicQuery } from "../services/aplms";
import Loader from "../loader/Loader";
import HTMLReactParser from "html-react-parser";
import Intro from "./Intro";
import Practicepaper from "./Practicepaper";
import { Link, useHistory } from "react-router-dom";
import { FaChevronUp, FaChevronDown } from "react-icons/fa6";

const Unit = (props) => {
  const history = useHistory();
  const accordionRef = useRef(null);
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(true);
  const [verticalScrollInterval, setVerticalScrollInterval] = useState(null);

  const goBackStepByStep = (step) => {
    for (let i = 0; i < step; i++) {
      history.goBack();
    }
  };
  const [introprops, setIntroprops] = useState();
  const topicdata = useGetAlltopicQuery(props.match.params.slug);
  const [openItem, setOpenItem] = useState(null); // Track the open accordion item

  useEffect(() => {
    if (topicdata.data && topicdata.data.length > 0) {
      // Sort the data before setting the initial topic
      const sortedData = sortTopicsByNumber([...topicdata.data]);
      const firstTopic = sortedData[0];
      setIntroprops(firstTopic.slug);
    }
  }, [topicdata.data]);

  // Monitor scroll position in the accordion container
  useEffect(() => {
    const accordionContainer = accordionRef.current;
    if (!accordionContainer) return;

    const handleScroll = () => {
      // Check if we can scroll up (not at the top)
      setCanScrollUp(accordionContainer.scrollTop > 10);

      // Check if we can scroll down (not at the bottom)
      const maxScrollTop = accordionContainer.scrollHeight - accordionContainer.clientHeight;
      setCanScrollDown(accordionContainer.scrollTop < maxScrollTop - 10);

      // Update CSS classes to show/hide arrows
      const upArrow = document.getElementById("accordion-scroll-up");
      const downArrow = document.getElementById("accordion-scroll-down");

      if (upArrow) {
        upArrow.classList.toggle("active", accordionContainer.scrollTop > 10);
      }

      if (downArrow) {
        downArrow.classList.toggle(
          "active", 
          accordionContainer.scrollTop < maxScrollTop - 10
        );
      }
    };

    // Initial check
    handleScroll();

    // Add scroll event listener
    accordionContainer.addEventListener("scroll", handleScroll);

    // Cleanup
    return () => {
      accordionContainer.removeEventListener("scroll", handleScroll);
      if (verticalScrollInterval) {
        clearInterval(verticalScrollInterval);
      }
    };
  }, [topicdata.data]); // Re-run when topics change

  // Scroll control functions
  const startScrollUp = () => {
    if (verticalScrollInterval) clearInterval(verticalScrollInterval);

    const accordionContainer = accordionRef.current;
    if (accordionContainer) {
      const scrollInterval = setInterval(() => {
        accordionContainer.scrollBy({
          top: -10,
          behavior: "auto",
        });

        // Stop if we reach the top
        if (accordionContainer.scrollTop <= 0) {
          clearInterval(scrollInterval);
          setVerticalScrollInterval(null);
        }
      }, 10);

      setVerticalScrollInterval(scrollInterval);
    }
  };

  const startScrollDown = () => {
    if (verticalScrollInterval) clearInterval(verticalScrollInterval);

    const accordionContainer = accordionRef.current;
    if (accordionContainer) {
      const scrollInterval = setInterval(() => {
        // Calculate maximum scroll position
        const maxScrollTop = accordionContainer.scrollHeight - accordionContainer.clientHeight;

        accordionContainer.scrollBy({
          top: 10,
          behavior: "auto",
        });

        // Stop if we reach the bottom
        if (accordionContainer.scrollTop >= maxScrollTop) {
          clearInterval(scrollInterval);
          setVerticalScrollInterval(null);
        }
      }, 10);

      setVerticalScrollInterval(scrollInterval);
    }
  };

  const stopScroll = () => {
    if (verticalScrollInterval) {
      clearInterval(verticalScrollInterval);
      setVerticalScrollInterval(null);
    }
  };

  if (topicdata.isLoading)
    return (
      <div>
        <Loader />
      </div>
    );
  if (topicdata.isError)
    return <h1>An error occurred: {topicdata.error.error}</h1>;

  // Function to sort topics by their numerical prefix
  const sortTopicsByNumber = (topics) => {
    return topics.sort((a, b) => {
      try {
        // Extract the numerical part from the beginning of the name
        const aMatch = String(a.name || '').match(/^(\d+)(?:\.(\d+))?/);
        const bMatch = String(b.name || '').match(/^(\d+)(?:\.(\d+))?/);
        
        // If there are no matches, return 0 (keep original order)
        if (!aMatch || !bMatch) return 0;
        
        // Get the major number (e.g., "1" from "1.2")
        const aMajor = parseInt(aMatch[1]) || 0;
        const bMajor = parseInt(bMatch[1]) || 0;
        
        // Compare major numbers
        if (aMajor !== bMajor) {
          return aMajor - bMajor;
        }
        
        // Get the minor number (e.g., "2" from "1.2"), default to 0 if not present
        const aMinor = parseInt(aMatch[2] || '0');
        const bMinor = parseInt(bMatch[2] || '0');
        
        // Compare minor numbers
        return aMinor - bMinor;
      } catch (error) {
        console.warn("Error sorting topics:", error);
        return 0; // Keep original order for problematic items
      }
    });
  };

  // Sort the topic data
  const sortedTopicData = sortTopicsByNumber([...topicdata.data]);

  return (
    <section>
      <Header />
      <div className="keyconcept-unit-section">
        <div className="breadcrumb-container pb-50">
          <div className="top-nav">
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to="/">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={"/AP/" + topicdata.data[0].curriculaslug}>
                  {topicdata.data[0].curriculaname}
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to={"/AP/" + topicdata.data[0].curriculaslug}>
                  {topicdata.data[0].subjname}
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span onClick={() => goBackStepByStep(2)}>
                  {topicdata.data[0].couresname}
                </span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span onClick={() => goBackStepByStep(1)}>
                  {topicdata.data[0].unitname}
                </span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <div className="ap-heading">
            <h2>{topicdata.data[0].couresname} - Key Concept</h2>
            <div className="heading-content">
              <div className="heading-description">
                <div className="hide-on-mobile">
                  <p>{HTMLReactParser(topicdata.data[0].description)}</p>
                </div>
              </div>
              <div className="heading-image">
                <div className="key-concept-top-right text-center">
                  <img src={Key_top} className="d" alt="Key concept" />
                  <img src={img_6} alt="Key concept" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="content-wrapper">
          <div className="sidebar">
            {/* Scroll arrows for accordion */}
            <div className="accordion-scroll-container">
              <div
                className="scroll-arrow-vertical scroll-arrow-up"
                id="accordion-scroll-up"
                onMouseDown={startScrollUp}
                onMouseUp={stopScroll}
                onMouseLeave={stopScroll}
                onTouchStart={startScrollUp}
                onTouchEnd={stopScroll}
                onTouchCancel={stopScroll}
              >
                <FaChevronUp />
              </div>
              <div
                className="scroll-arrow-vertical scroll-arrow-down"
                id="accordion-scroll-down"
                onMouseDown={startScrollDown}
                onMouseUp={stopScroll}
                onMouseLeave={stopScroll}
                onTouchStart={startScrollDown}
                onTouchEnd={stopScroll}
                onTouchCancel={stopScroll}
              >
                <FaChevronDown />
              </div>
            </div>
            
            <div 
              className="accordion-container" 
              ref={accordionRef}
            >
              <Accordion activeKey={openItem}>
                {sortedTopicData.map((topic) => (
                  <Accordion.Item
                    eventKey={topic.slug}
                    key={topic.slug}
                    className="custom-accordion-item"
                  >
                    <Accordion.Header
                      onClick={() => {
                        setOpenItem(openItem === topic.slug ? null : topic.slug);
                        setIntroprops(topic.slug);
                      }}
                      aria-controls="example-collapse-text"
                      aria-expanded={openItem === topic.slug}
                    >
                      {topic.name}
                    </Accordion.Header>
                    {openItem === topic.slug && (
                      <Accordion.Body>
                        <Practicepaper propspaperData={topic.slug} />
                      </Accordion.Body>
                    )}
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>
          <div className="main-content">
            <Intro propsintroData={introprops} />
          </div>
        </div>

        <Footer />
      </div>
    </section>
  );
};

export default Unit;